jQuery(document).ready(function($) {
  const $sbiImages = $('#sbi_images');
  const $items = $sbiImages.find('.sbi_item').clone(); // .sbi_item を複製
  const $carouselInner = $('<div class="sbi_carousel_inner"/>').css('display', 'flex');

  // カルーセル内部ラップを作成し、元のアイテムとその複製を追加
  $carouselInner.append($sbiImages.find('.sbi_item')).append($items);
  $sbiImages.append($carouselInner); // #sbi_images にカルーセル内部ラップを追加

  const itemWidth = $('.sbi_item').outerWidth(true);
  const margin = 12; // 各要素の余白（12px）
  const totalItems = $carouselInner.find('.sbi_item').length;
  const totalWidth = (itemWidth + margin) * totalItems; // 要素の幅と余白を考慮

  // .sbi_carousel_inner の幅を動的に設定
  $carouselInner.css('width', totalWidth + 'px');

  function scrollInstagramFeed() {
      let currentMargin = parseInt($carouselInner.css('margin-left'));
      let newMargin = currentMargin - 1;
      if (Math.abs(newMargin) > totalWidth / 2) { // 半分スクロールしたらリセット
          newMargin = 0;
          $carouselInner.append($carouselInner.find('.sbi_item').slice(0, totalItems / 2)); // 最初の要素を末尾に移動
      }
      $carouselInner.css('margin-left', newMargin + 'px');
  }

  setInterval(scrollInstagramFeed, 30); // 速度は30ミリ秒ごとに1ピクセル
});



